import { render, staticRenderFns } from "./home_goods_list.vue?vue&type=template&id=5d60d90a&scoped=true&"
import script from "./home_goods_list.vue?vue&type=script&lang=js&"
export * from "./home_goods_list.vue?vue&type=script&lang=js&"
import style0 from "./home_goods_list.vue?vue&type=style&index=0&id=5d60d90a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d60d90a",
  null
  
)

export default component.exports